import { FC, useMemo } from 'react';
import { Helmet } from 'react-helmet';

import { CoreStatusExtended } from 'types';
import { PageHeader } from 'shared-components';

import { TravelStatus } from './travel-status';
import { AccommodationStatus } from './accommodation-status';
import { IAccommodationStatus, ITravelStatus, IVisaStatus } from '../../../../types';
import { VisaStatus } from './visa-status';
import PageSubtext from '../../../atoms/PageSubtext';
import { titleAppend } from '../../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'frontend/student/src/store';
import { createNavigateToAction } from '../../../../middleware/actions';
import * as studentActions from '../../../../store/student/actions';

const EnrolmentStatus = () => {
  const dispatch = useDispatch();
  const offerStatus = useSelector((state: ApplicationState) => state.student.offer.status);
  const visaStatus = useSelector((state: ApplicationState) => state.student.offer.visaStatus);
  const travelStatusSection = useSelector(
    (state: ApplicationState) => state.student.enrolmentStatus.travelStatusSection
  );
  const accommodationStatusSection = useSelector(
    (state: ApplicationState) => state.student.enrolmentStatus.accommodationStatusSection
  );
  const universityAccommodationEnabled = useSelector(
    (state: ApplicationState) => state.config.universityAccommodationEnabled
  );

  const saveTravelStatus = (data: ITravelStatus) => {
    createNavigateToAction('/');
    dispatch(studentActions.saveTravelStatus(data));
  };
  const saveVisaStatus = (data: { status: IVisaStatus }) => {
    createNavigateToAction('/');
    dispatch(studentActions.saveVisaStatus(data));
  };
  const saveAccommodationStatus = (data: IAccommodationStatus) => {
    createNavigateToAction('/');
    dispatch(studentActions.saveAccommodationStatus(data));
  };

  const finishedVisaStatuses = useMemo(
    () => [CoreStatusExtended.CAS_ISSUED, CoreStatusExtended.VISA_ISSUED, CoreStatusExtended.VISA_REFUSED],
    []
  );

  const showVisaAndAccommodationStatusSection = useMemo(
    () => finishedVisaStatuses.includes(offerStatus),
    [finishedVisaStatuses, offerStatus]
  );

  const showTravelStatusSection = useMemo(() => offerStatus === CoreStatusExtended.VISA_ISSUED, [offerStatus]);

  const pageTitle = 'Enrolment Status';

  return (
    <>
      <Helmet>
        <title>
          {pageTitle} {titleAppend}
        </title>
      </Helmet>

      <PageHeader>{pageTitle}</PageHeader>

      <PageSubtext>Please keep us updated on your status whenever your situation changes.</PageSubtext>

      {showVisaAndAccommodationStatusSection && <VisaStatus visaStatus={visaStatus} saveVisaStatus={saveVisaStatus} />}
      {showTravelStatusSection && (
        <TravelStatus travelStatus={{ ...travelStatusSection }} saveTravelStatus={saveTravelStatus} />
      )}
      {showVisaAndAccommodationStatusSection && (
        <AccommodationStatus
          accommodationStatus={{ ...accommodationStatusSection }}
          saveAccommodationStatus={saveAccommodationStatus}
          universityAccommodationEnabled={universityAccommodationEnabled}
        />
      )}
    </>
  );
};

export default EnrolmentStatus;
